import { Stack } from "@mui/material";
import { useSession } from "@src/appV2/Auth/api/useSession";
import { useTu } from "@src/appV2/i18n/useTu";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { useThemeMode } from "@src/appV2/UserPreferences/UserPreferencesProvider";

import { AccountSwitcherMobile } from "../AccountSwitcher/AccountSwitcher";
import { WorkplaceContextTitle } from "../../Shared/Header/WorkplaceContextTitle";

export interface NavigationMenuHeaderMobileProps {
  onClose: () => void;
}

export function NavigationMenuHeaderMobile(props: NavigationMenuHeaderMobileProps) {
  const { tu } = useTu("navigation");
  const { onClose } = props;
  const { themeMode } = useThemeMode();
  const { admin, profile, user } = useSession();
  const isDark = themeMode === "dark";
  const closeVariant = isDark ? "outlineInverted" : "link";
  const showWorkplaceTitle = Boolean(profile?.name);
  // Non-admin users with multiple workplaces get the switcher in the title
  // slot; admins and single-workplace users see the plain workplace title.
  const hasMultipleWorkplaces = !admin && (user?.facilityIds?.length ?? 0) > 1;

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={3}
      flexGrow={0}
      flexShrink={0}
      sx={{ paddingBottom: 2 }}
    >
      <Stack flex={1} minWidth={0}>
        {hasMultipleWorkplaces ? (
          <AccountSwitcherMobile />
        ) : (
          showWorkplaceTitle && <WorkplaceContextTitle />
        )}
      </Stack>
      <IconButton
        variant={closeVariant}
        iconType="close"
        size="large"
        aria-label={tu("Close menu")}
        onClick={onClose}
        sx={{ border: "none", aspectRatio: "1", flexShrink: 0 }}
      />
    </Stack>
  );
}
